import {connect} from 'react-redux';
import ManageGroupEdit from '../pages/ManageGroupEdit';

export default connect(
    (state) => ({
        groups: state.manageGroup.groups,
    }),
)(ManageGroupEdit);